// Long lists shown in parts: <ul data-show-more="24" id="list"> followed by
// a hidden <div class="show-more"> with a button (aria-controls="list") and
// a .show-more__count. Without JavaScript the whole list stays visible.
export default function showMore() {
  document.querySelectorAll('[data-show-more]').forEach((list) => {
    const step = Number(list.dataset.showMore) || 24;
    const items = Array.from(list.children);
    const button = document.querySelector(`.show-more [aria-controls="${list.id}"]`);
    if (!button || items.length <= step) return;

    const wrap = button.closest('.show-more');
    const count = wrap.querySelector('.show-more__count');
    let shown = step;

    const update = () => {
      items.forEach((item, i) => {
        item.hidden = i >= shown;
      });
      const left = items.length - shown;
      count.textContent = `(${left})`;
      wrap.hidden = left <= 0;
    };

    button.addEventListener('click', () => {
      const first = items[shown];
      shown += step;
      update();
      // Keyboard and screen reader users continue from the first new shop
      const link = first.querySelector('a');
      if (link) link.focus({ preventScroll: true });
    });

    update();
  });
}
